import React from 'react'
import Style from './style.module.css'

const LeftSidePopupLayout = ({ onClose, children, className, overlayClassName, style, popupStatus=false }) => {
    return (
        <div className={`${Style.modal_overlay} ${popupStatus ? Style.show : Style.hide} ${overlayClassName}`} onClick={onClose}>
            <div className={`${Style.customize_modal} ${className}`} style={style} onClick={(e) => e.stopPropagation()}>
                {children}
            </div>
        </div>
    )
}

export default LeftSidePopupLayout
